export const ALERT_VARIANTS = {
    success: 'success',
    warning: 'warning',
    error: 'error',
    info: 'info',
};
export const getBackgroundColorByTheme = (theme, variant) => {
    switch (variant) {
        case ALERT_VARIANTS.success: {
            return theme.palette.success.main;
        }
        case ALERT_VARIANTS.warning: {
            return theme.palette.warning.main;
        }
        case ALERT_VARIANTS.error: {
            return theme.palette.error.main;
        }
        case ALERT_VARIANTS.info: {
            return theme.palette.info.main;
        }
    }
    return '';
};
export const getTextColorByTheme = (theme, variant) => {
    if (theme.name === 'liquidity' && variant === ALERT_VARIANTS.warning)
        return theme.palette.warning.contrastText;
    return 'inherit';
};
//# sourceMappingURL=AlertVariants.js.map